import React, { useEffect } from "react";
import { useLoaderData } from "react-router";

import "react-datepicker/dist/react-datepicker.css";

import UmpiresTable from "./components/UmpiresTable";
import TableFilters from "./components/TableFilters";
import { useUmpiresContext } from "../../contexts/Umpires";

import "../../../../../assets/css/umphub/pages/admin.scss";
import Pagination from "../../../../../components/Pagination";
import { PaginationProvider } from "../../../../../contexts/Pagination";
import { IUmpireUser } from "../../../../../types/api";

export const loader = async ({ type }: any) => {
    return type;
};

const Umpires = (): React.JSX.Element => {
    const type = useLoaderData() as IUmpireUser["status"];
    const { setType } = useUmpiresContext();
    useEffect(() => {
        setType(type);
    }, [type, setType]);

    return (
        <PaginationProvider>
            <TableFilters />
            <UmpiresTable />
            <Pagination useContext={useUmpiresContext} />
        </PaginationProvider>
    );
};

export default Umpires;
